import { render, staticRenderFns } from "./FrzChamberCustomerBrandDetail.vue?vue&type=template&id=21682490"
import script from "./FrzChamberCustomerBrandDetail.vue?vue&type=script&lang=js"
export * from "./FrzChamberCustomerBrandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports